import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, Link } from 'react-router-dom';
import DataTable from 'react-data-table-component';

import { buscarSucursales } from '../../actions/sucursales';
import { buscarEventos } from '../../actions/eventos';
import { editarBreadcrumb } from '../../actions/breadcrumb';

import EliminarSucursal from './EliminarSucursal';
import FiltrosSucursal from './FiltrosSucursal';

const tiposSucursal = [
    { value: 0, label: 'Fija' },
    { value: 1, label: 'Móvil' }
];

const filtrosVacios = { nombre: '', tipo: null, evento: null };

const Sucursales = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { listado } = useSelector(state => state.sucursales);

    const [sucursalEliminar, setSucursalEliminar] = useState(null);
    const [filtrosModal, setFiltrosModal] = useState(false);
    const [filtros, setFiltros] = useState(filtrosVacios);

    useEffect(() => {
        dispatch(buscarEventos(false));
        dispatch(buscarSucursales(filtrosVacios));
        dispatch(editarBreadcrumb([
            { nombre: 'Sucursales', path: '/sucursales', activo: true }
        ]));
    }, []);

    const handleAplicarFiltros = (nuevosFiltros) => {
        setFiltros(nuevosFiltros);
        dispatch(buscarSucursales(nuevosFiltros));
    };

    const filtrosActivos = [filtros.nombre, filtros.tipo !== null, filtros.evento].filter(Boolean).length;

    const columns = [
        {
            name: 'Nombre',
            sortable: true,
            selector: row => row.nombre || '-',
            grow: 2
        },
        {
            name: 'Dirección',
            sortable: true,
            selector: row => row.direccion || '-',
            grow: 2
        },
        {
            name: 'Tipo',
            sortable: true,
            selector: row => {
                const tipo = tiposSucursal.find(t => t.value === row.tipo);
                return tipo ? tipo.label : '-';
            }
        },
        {
            name: 'Evento',
            sortable: true,
            selector: row => row.evento?.nombre || '-',
            grow: 1.5
        },
        {
            name: 'Acciones',
            cell: row => (
                <div>
                    <Link className="btn btn-sm btn-info me-1" to={`/sucursales/detalles/${row._id}`}>
                        <i className="fas fa-eye"></i>
                    </Link>
                    <button className="btn btn-sm btn-warning me-1" onClick={() => navigate(`/sucursales/editar/${row._id}`)}>
                        <i className="fas fa-edit"></i>
                    </button>
                    <button className="btn btn-sm btn-danger" onClick={() => setSucursalEliminar(row)}>
                        <i className="fas fa-trash"></i>
                    </button>
                </div>
            )
        }
    ];

    return (
        <div className="row mt-5">
            <div className="col-12 mb-3 d-flex justify-content-between align-items-center">
                <h4 className="mb-4">Sucursales</h4>
                <div className="d-flex gap-3">
                    <button className="btn btn-secondary position-relative" onClick={() => setFiltrosModal(true)}>
                        <i className="fas fa-filter me-1"></i> Filtros
                        {filtrosActivos > 0 && (
                            <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-primary">
                                {filtrosActivos}
                            </span>
                        )}
                    </button>
                    <button className="btn btn-primary" onClick={() => navigate('/sucursales/nuevo')}>
                        <i className="fas fa-plus me-1"></i> Nueva sucursal
                    </button>
                </div>
            </div>

            <div className="col-12">
                <DataTable
                    columns={columns}
                    data={listado}
                    pagination
                    paginationPerPage={20}
                    paginationComponentOptions={{ rowsPerPageText: 'Filas por página', rangeSeparatorText: 'de' }}
                    highlightOnHover
                    noDataComponent={<p className="text-center py-3">No hay sucursales registradas</p>}
                />
            </div>

            <FiltrosSucursal
                show={filtrosModal}
                handleCerrar={() => setFiltrosModal(false)}
                filtros={filtros}
                handleAplicar={handleAplicarFiltros}
            />

            <EliminarSucursal sucursal={sucursalEliminar} handleCerrar={() => setSucursalEliminar(null)} />
        </div>
    );
};

export default Sucursales;
